export interface AppConfigState {
  widgetIsOpen: boolean;
}

export const AppConfigEmptyState: AppConfigState = {
  widgetIsOpen: false,
};
